<template>
  <div class="automation">
    <div class="automation__heading">
      <a href="#">
        {{ location.name }}
        <i class="d-inline-block ml-3 fa-solid fa-arrow-up-right-from-square text-muted" />
      </a>
      <span v-if="location.storeCode">{{ location.storeCode }}</span>
      <p v-if="location.address">
        {{ location.address }}
      </p>
    </div>
    <div class="automation__toggles">
      <CheckboxToggle
        v-for="panel in panels"
        :key="panel.key"
        v-model="panel.visible"
        :disabled="panel.disabled"
        class="reverse">
        <strong>{{ panel.caption }}</strong>
      </CheckboxToggle>
    </div>
    <template v-for="panel in panels">
      <Wrapper
        v-if="panel.visible"
        :key="panel.key"
        :head-url="panel.headUrl"
        class="mb-5">
        <template #title>
          {{ panel.caption }}
        </template>
        <compontent
          v-if="panel.compontent"
          :is="panel.compontent"
          :location-id="location.id"
          :open-ai-key-present="openAiKeyPresent" />
      </Wrapper>
    </template>
  </div>
</template>

<script>
import CheckboxToggle from 'vue_widgets/components/checkbox_toggle'
import Wrapper from './wrapper.vue'
import Reports from './reports.vue'
import AuditReports from './audits.vue'
import Geogrids from './geogrids.vue'
import AIAutopilot from './ai_autopilot.vue'

export default {
  components: {
    CheckboxToggle,
    Wrapper,
    Reports,
    AuditReports,
    Geogrids,
    AIAutopilot
  },
  props: {
    location: { type: Object, required: true },
    openAiKeyPresent: { type: Boolean, required: true },
    report: { type: Object, default: null }
  },
  data() {
    return {
      // panels: {
      //   reviews: { caption: 'Reviews', visible: true },
      //   reports: { caption: 'Reports', visible: true },
      //   audits: { caption: 'Audit reports', visible: false, disabled: true },
      //   geogrids: { caption: 'Geogrids', visible: false, disabled: true },
      //   qa: { caption: 'Q&A', visible: false, disabled: true }
      // },
      panels: [
        {
          caption: 'Reviews',
          visible: true,
          key: 'reviews',
          headUrl: { caption: 'All reviews', url: '#' },
          compontent: 'AIAutopilot'
        },
        {
          caption: 'Reports',
          visible: true,
          key: 'reports',
          headUrl: { caption: 'All reports', url: '#' },
          compontent: 'Reports'
        },
        {
          caption: 'Audit reports',
          visible: true,
          key: 'audits',
          headUrl: { caption: 'All audits', url: '#' },
          compontent: 'AuditReports'
        },
        {
          caption: 'Geogrids',
          visible: false,
          key: 'geogrids',
          headUrl: { caption: 'All geogrids', url: '#' },
          compontent: 'Geogrids'
        },
        {
          caption: 'Q&A',
          visible: false,
          key: 'qa'
        }
      ]
    }
  }
}
</script>
